export function removeItem<T>(items: T[], itemToRemove: T) {
    const index = items.indexOf(itemToRemove);

    if (index !== -1) {
        items.splice(index, 1);
    }
}
